import React from 'react'
import ChartistGraph from 'react-chartist'

import './chartist.min.css'

export default class Bar extends React.Component {
  render() {

    const { score } = this.props
    const scores = []
    const scoresInner = []
    scoresInner.push(score)
    scores.push(scoresInner)

    const data = {
      series: scores
    }

    const options = {
      high: 30,
      low: -30,
      horizontalBars: true,
      width: '300px',
      fullWidth: true,
      chartPadding: 0,
      seriesBarDistance: 0,
      height: '14px',
      axisX: {
        labelInterpolationFnc: function(value, index) {
          return index % 2 === 0 ? value : null;
        },
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      axisY: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
    }

    const listener = {
      draw: function(data) {
        if(data.value.x > 0) {
          data.element.attr({
            class: 'ct-bar positive'
          });
        } else if(data.value.x === 0) {
          data.element.attr({
            class: 'ct-bar positive neutral'
          });
        } else if(data.value.x < 0) {
          data.element.attr({
            class: 'ct-bar negative'
          });
        }
      }
    }

    let valueScale = 'bar-container'
      if (score > 0)
        valueScale += ' div-positive'
      else if (score === 0)
        valueScale += ' div-positive div-neutral'
      else if (score < 0)
        valueScale += ' div-negative'

    const type = 'Bar'
    const aspectRatio = 'ct-octave'

    return (
      <div className={valueScale}>
        <ChartistGraph className={aspectRatio} listener={listener} data={data} options={options} type={type} />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Bar.js